import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class ListGroupSubheader extends PureComponent {
  static displayName = 'ListGroupSubheader'

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  render() {
    const {
      children,
      className,
      ...otherProps,
    } = this.props
    const cssClasses = classNames('mdc-list-group__subheader', className)
    return (
      <div
        {...otherProps}
        className={cssClasses}
      >
        {children}
      </div>
    )
  }
}

export default ListGroupSubheader



// WEBPACK FOOTER //
// ./src/List/ListGroupSubheader.js